var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"my-5":""}},[_c('p',{staticClass:"display-1 text-xs-center mb-3"},[_vm._v("Please launch Brainingcamp from your Classlink launchpad.")])])}
var staticRenderFns = []

export { render, staticRenderFns }